import * as React from 'react';

function IconClose(_a) {
    var ariaLabel = _a.ariaLabel;
    return (React.createElement("svg", { "aria-label": ariaLabel, height: "16", viewBox: "0 0 20 20", width: "16", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M19.582.418c.523.523.555 1.351.098 1.912l-.098.109L12.02 10l7.562 7.561a1.429 1.429 0 01-1.912 2.119l-.109-.098L10 12.02l-7.561 7.562A1.429 1.429 0 01.32 17.67l.098-.109L7.98 10 .418 2.439A1.429 1.429 0 012.33.32l.109.098L10 7.98 17.561.418a1.429 1.429 0 012.02 0z", fill: "#323336", fillRule: "evenodd" })));
}

export { IconClose as default };
//# sourceMappingURL=IconClose.esm.js.map
